import { Base } from "@app/controllers/base"

export default class extends Base {
  static targets = ["grid", "map", "gridBtn", "mapBtn"]

  connect() {
    // Show grid by default
    this.showGrid()
  }

  showGrid() {
    this._toggle(true)
  }

  showMap() {
    this._toggle(false)
  }

  _toggle(isGrid) {
    if (isGrid) {
      // Toggle visibility
      this.gridTarget.classList.remove("hidden")
      this.mapTarget.classList.add("hidden")

      // Button styles
      this.gridBtnTarget.classList.add("bg-white", "text-navy", "shadow-sm")
      this.gridBtnTarget.classList.remove("text-muted-foreground", "hover:text-foreground")

      this.mapBtnTarget.classList.remove("bg-white", "text-navy", "shadow-sm")
      this.mapBtnTarget.classList.add("text-muted-foreground", "hover:text-foreground")
    } else {
      // Toggle visibility
      this.gridTarget.classList.add("hidden")
      this.mapTarget.classList.remove("hidden")

      // Button styles
      this.mapBtnTarget.classList.add("bg-white", "text-navy", "shadow-sm")
      this.mapBtnTarget.classList.remove("text-muted-foreground", "hover:text-foreground")

      this.gridBtnTarget.classList.remove("bg-white", "text-navy", "shadow-sm")
      this.gridBtnTarget.classList.add("text-muted-foreground", "hover:text-foreground")

      // Trigger Leaflet resize recalculation once the container is visible
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"))
      }, 50)
    }
  }
}
